/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import './content-block-card-static';
import '../button-group/index';
import '../card-group/index';
import '../content-item/index';
import '../content-block/content-block-heading';
import '../cta/card-cta-footer';
import '../cta/video-cta-container';
